import { DownloadFile, enqueueSnackbar } from 'actions';

import {
	GetFailuresVoiceRequest,
	SetFailureVoiceValidInvalidRequest,
	GetFailureVoiceDetailsRequest,
	GetFailureVoiceCommentsRequest,
	SetFailureVoiceDetailsRequest,
	AddVoiceCommentRequest,
	ExportFailuresVoiceRequest,
	GetVoiceLevelsRequest,
	// Layer 3
	GetLayer3Request,
	GetLayer3MessageMoRequest,
	GetLayer3MessageMtRequest,
	GetLayer3FailureRequest,
	GetLayer3DriveTestRequest,
	GetLayer3KpisRequest
} from '../requests/VoiceRequest';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const TOGGLE_OPTIONS_FAILURES_TRACKER_DIALOG = 'TOGGLE_OPTIONS_FAILURES_TRACKER_DIALOG';
export const GET_FAILURES_VOICE = 'GET_FAILURES_VOICE';
export const TOGGLE_VOICE_EDIT_FAILURE_DIALOG = 'TOGGLE_VOICE_EDIT_FAILURE_DIALOG';
export const GET_FAILURE_VOICE_DETAILS = 'GET_FAILURE_VOICE_DETAILS';
export const GET_FAILURE_VOICE_COMMENTS = 'GET_FAILURE_VOICE_COMMENTS';
export const EXPORT_FAILURES_VOICE = 'EXPORT_FAILURES_VOICE';
export const TOGGLE_LAYER_3_DIALOG = 'TOGGLE_LAYER_3_DIALOG';
export const GET_VOICE_CFN_2_LEVELS = 'GET_VOICE_CFN_2_LEVELS';
export const GET_VOICE_CFN_3_LEVELS = 'GET_VOICE_CFN_3_LEVELS';
// layer 3
export const GET_LAYER_3 = 'GET_LAYER_3';
export const GET_LAYER_3_MESSAGE_MO = 'GET_LAYER_3_MESSAGE_MO';
export const GET_LAYER_3_MESSAGE_MT = 'GET_LAYER_3_MESSAGE_MT';
export const GET_LAYER_3_FAILURE = 'GET_LAYER_3_FAILURE';
export const GET_LAYER_3_DRIVETEST = 'GET_LAYER_3_DRIVETEST';
export const GET_LAYER_3_KPIS = 'GET_LAYER_3_KPIS';

// Other
const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onToggleOptionsFailuresTrackerDialog = visible => ({
	type: TOGGLE_OPTIONS_FAILURES_TRACKER_DIALOG,
	visible
});

// Failures
const onGetFailuresVoice = (value) => ({
	type: GET_FAILURES_VOICE,
	failures: value
});

const onToggleVoiceEditFailureDialog = (visible, tableId, filenameMoc, filenameMtc, failureSide, failureType, initialTimestamp) => ({
	type: TOGGLE_VOICE_EDIT_FAILURE_DIALOG,
	visible,
	tableId,
	filenameMoc,
	filenameMtc,
	failureSide,
	failureType,
	initialTimestamp
});

const onGetFailureVoiceDetails = (value) => ({
	type: GET_FAILURE_VOICE_DETAILS,
	failure: value
});

const onGetFailureVoiceComments = (value) => ({
	type: GET_FAILURE_VOICE_COMMENTS,
	comments: value
});

const onGetVoiceCfn2Levels = (value) => ({
	type: GET_VOICE_CFN_2_LEVELS,
	voiceCfn2Levels: value
});

const onGetVoiceCfn3Levels = (value) => ({
	type: GET_VOICE_CFN_3_LEVELS,
	voiceCfn3Levels: value
});

// Layer3
const onToggleLayer3Dialog = (visible) => ({
	type: TOGGLE_LAYER_3_DIALOG,
	visible
});

const onGetLayer3 = (value) => ({
	type: GET_LAYER_3,
	layer3: value
});

const onGetLayer3MessageMo = (value) => ({
	type: GET_LAYER_3_MESSAGE_MO,
	layer3MessageMo: value
});

const onGetLayer3MessageMt = (value) => ({
	type: GET_LAYER_3_MESSAGE_MT,
	layer3MessageMt: value
});

const onGetLayer3Failure = (value) => ({
	type: GET_LAYER_3_FAILURE,
	layer3Failure: value
});

const onGetLayer3DriveTest = (value) => ({
	type: GET_LAYER_3_DRIVETEST,
	layer3DriveTest: value
});

const onGetLayer3Kpis = (value) => ({
	type: GET_LAYER_3_KPIS,
	layer3Kpis: value
});

// Other
export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ToggleOptionsFailuresTrackerDialog = visible => dispatch => {
	dispatch(onToggleOptionsFailuresTrackerDialog(visible));
};

// Failures
export const GetFailuresVoice = (userId, role) => async (dispatch) => {
	await GetFailuresVoiceRequest(userId, role).then(response => {
		dispatch(onGetFailuresVoice(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFailureVoiceValidInvalid = (userId, role, id) => async (dispatch) => {
	await SetFailureVoiceValidInvalidRequest(userId, id).then(response => {
		dispatch(GetFailuresVoice(userId, role));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleVoiceEditFailureDialog = (visible, tableId, filenameMoc, filenameMtc, failureSide, failureType, initialTimestamp) => (dispatch) => {
	dispatch(onToggleVoiceEditFailureDialog(visible, tableId, filenameMoc, filenameMtc, failureSide, failureType, initialTimestamp));
};

export const GetFailureVoiceDetails = (id, userId) => async (dispatch) => {
	await GetFailureVoiceDetailsRequest(id, userId).then(response => {
		dispatch(onGetFailureVoiceDetails(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetFailureVoiceComments = (id) => async (dispatch) => {
	await GetFailureVoiceCommentsRequest(id).then(response => {
		dispatch(onGetFailureVoiceComments(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFailureVoiceDetails = (failure, userId, role) => async (dispatch) => {
	await SetFailureVoiceDetailsRequest(failure, userId).then(response => {
		dispatch(GetFailuresVoice(userId, role));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const AddVoiceComment = (id, userId, comment) => async (dispatch) => {
	await AddVoiceCommentRequest(id, userId, comment).then(response => {
		dispatch(GetFailureVoiceComments(id));
		dispatch(GetFailureVoiceDetails(id));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ExportFailuresVoice = (userId, role) => async (dispatch) => {
	await ExportFailuresVoiceRequest(userId, role).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetVoiceCfn2Levels = (level) => async (dispatch) => {
	await GetVoiceLevelsRequest('Cfn2Levels', level).then(response => {
		dispatch(onGetVoiceCfn2Levels(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetVoiceCfn3Levels = (level) => async (dispatch) => {
	await GetVoiceLevelsRequest('Cfn3Levels', level).then(response => {
		dispatch(onGetVoiceCfn3Levels(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Layer3
export const ToggleLayer3Dialog = (visible) => (dispatch) => {
	dispatch(onToggleLayer3Dialog(visible));
};

export const GetLayer3 = (filenameMoc, filenameMtc, initialTimestamp, userId) => async (dispatch) => {
	await GetLayer3Request(filenameMoc, filenameMtc, initialTimestamp, userId).then(response => {
		dispatch(onGetLayer3(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetLayer3 = (data) => async (dispatch) => {
	dispatch(onGetLayer3(data));
};

export const GetLayer3MessageMo = (id, date, side, userId, filename) => async (dispatch) => {
	await GetLayer3MessageMoRequest(id, date, side, userId, filename).then(response => {
		dispatch(onGetLayer3MessageMo(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetLayer3MessageMt = (id, date, side, userId, filename) => async (dispatch) => {
	await GetLayer3MessageMtRequest(id, date, side, userId, filename).then(response => {
		dispatch(onGetLayer3MessageMt(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetLayer3Failure = (id) => async (dispatch) => {
	await GetLayer3FailureRequest(id).then(response => {
		dispatch(onGetLayer3Failure(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetLayer3DriveTest = (userId, kpi, filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime) => async (dispatch) => {
	await GetLayer3DriveTestRequest(userId, kpi, filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime).then(response => {
		dispatch(onGetLayer3DriveTest(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetLayer3Kpis = (filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime) => async (dispatch) => {
	await GetLayer3KpisRequest(filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime).then(response => {
		dispatch(onGetLayer3Kpis(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
